import { createSlice } from "@reduxjs/toolkit";

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    subscription:{
      id: 1,
      title: "Premium",
      price: 299.99,
      duration: "1 Year",
    }
    // subscription: null,
  },
  reducers:{
    setSubscription: (state, action) => {
      state.subscription = action.payload;
    },
    clearSubscription: (state) => {
      state.subscription = {
        id: 1,
        title: "Premium",
        price: 299.99,
        duration: "1 Year",
      };
    },
    reset: (state) => {
      state.subscription = {
        id: 1,
        title: "Premium",
        price: 299.99,
        duration: "1 Year",
      };
    },
  },
});

export const { setSubscription, clearSubscription, reset } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
